import React, { useRef } from "react";
import { clamp, clampOffset, dist, centroid } from "./storyEditorUtils";

// Fond de la story (dégradé/image ou photo/vidéo). Avec un média : 1 doigt = recadrer (glisser),
// 2 doigts = zoomer (pincer). Un tap sur le fond désélectionne le sticker courant.
export const StoryMediaLayer = ({ hasMedia, transform, setTransform, frameRef, onBackgroundTap, disabled, children }) => {
  const g = useRef(null);
  const down = (e) => {
    if (e.target?.closest?.("[data-sticker],button,a,input,textarea")) return;
    onBackgroundTap?.();
    if (!hasMedia) return;
    e.currentTarget.setPointerCapture(e.pointerId);
    const cur = g.current || { pts: new Map() };
    cur.pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    const arr = [...cur.pts.values()];
    cur.start = { x: transform.x, y: transform.y, scale: transform.scale, c: centroid(arr), d: arr.length >= 2 ? dist(arr[0], arr[1]) : 0 };
    g.current = cur;
  };
  const move = (e) => {
    const cur = g.current;
    if (!cur || !cur.pts.has(e.pointerId)) return;
    cur.pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    const r = frameRef.current.getBoundingClientRect();
    const arr = [...cur.pts.values()];
    const c = centroid(arr);
    const scale = arr.length >= 2 && cur.start.d > 0 ? clamp(cur.start.scale * (dist(arr[0], arr[1]) / cur.start.d), 1, 3) : cur.start.scale;
    const { x, y } = clampOffset(cur.start.x + ((c.x - cur.start.c.x) / r.width) * 100, cur.start.y + ((c.y - cur.start.c.y) / r.height) * 100, scale);
    setTransform({ scale, x, y });
  };
  const up = (e) => {
    const cur = g.current;
    if (!cur || !cur.pts.has(e.pointerId)) return;
    cur.pts.delete(e.pointerId);
    if (cur.pts.size === 0) { g.current = null; return; }
    const arr = [...cur.pts.values()];
    cur.start = { x: transform.x, y: transform.y, scale: transform.scale, c: centroid(arr), d: arr.length >= 2 ? dist(arr[0], arr[1]) : 0 };
  };
  return (
    <div
      className={`absolute inset-0 touch-none ${disabled ? "pointer-events-none" : ""}`}
      onPointerDown={down}
      onPointerMove={move}
      onPointerUp={up}
      onPointerCancel={up}
      data-testid="story-fs-media-layer"
    >
      {children}
    </div>
  );
};
